import { ChevronRight } from "lucide-react";
import React from "react";
import {
  Avatar,
  createStyles,
  Group,
  Text,
  UnstyledButton,
} from "@mantine/core";
import Author from "../../../common/model/Author";

type SurveyResponseSubmissionCardProps = {
  id: number;
  firstName: string;
  lastName: string;
  selection?: Author;
  onSelect: () => void;
};

const useStyles = createStyles((theme) => ({
  user: {
    display: "block",
    width: "100%",
    padding: theme.spacing.md,
    backgroundColor: "#ffffff",
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    borderRadius: "4px",
    "&:hover": {
      color: "#062133",
      backgroundColor: "rgba(98, 93, 245, 0.1)",
    },
  },
  userSelected: {
    background: "rgba(98, 93, 245, 0.1)",
    color: "#062133",
  },

  // borderRight: "0.15rem solid #625DF5",
}));

const SurveyResponseSubmissionCard: React.FC<
  SurveyResponseSubmissionCardProps
> = ({ id, firstName, lastName, onSelect, selection }) => {
  const { classes, cx } = useStyles();

  return selection ? (
    <UnstyledButton
      key={`select-respondent-${id}`}
      className={cx(classes.user, {
        [classes.userSelected]: Object.is(id, selection.id),
      })}
      onClick={() => onSelect()}
    >
      <Group>
        <Avatar size={40} radius="xl">
          {" "}
          {`${firstName[0]}${lastName[0]}`}
        </Avatar>
        <div style={{ flex: 1 }}>
          <Text size="sm" weight={500}>
            {`${firstName} ${lastName}`}
          </Text>

          <Text color="dimmed" size="xs">
            #{id}
          </Text>
        </div>

        <ChevronRight size={14} />
      </Group>
    </UnstyledButton>
  ) : (
    <UnstyledButton
      key={`select-respondent-${id}`}
      className={cx(classes.user)}
    >
      <Group>
        <Avatar size={40} radius="xl" />
        <div style={{ flex: 1 }}>
          <Text size="sm" weight={500}>
            No Respondent
          </Text>
        </div>

        <ChevronRight size={14} />
      </Group>
    </UnstyledButton>
  );
};

export default SurveyResponseSubmissionCard;
